import { render, staticRenderFns } from "./App.vue?vue&type=template&id=7ffea5ed"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=7ffea5ed&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15__byh6baypi74voqda52fdqis3fu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports